import React from "react";
import Loader from "../Pages/Loader";

const MatchingReport = ({ postData, kundliMatchDetails }) => {


      console.log(postData); // Debug output
      console.log(kundliMatchDetails); // Debug output
      if (!postData || !kundliMatchDetails) return <Loader/>;

    const {
      boy_name,
      boy_birthplace,
      boy_dob,
      boy_tob,
      girl_name,
      girl_birthplace,
      girl_dob,
      girl_tob,
    } = postData;


  const matchAttributes = [
    "tara",
    "gana",
    "yoni",
    "bhakoot",
    "grahamaitri",
    "vasya",
    "nadi",
    "varna",
  ];

  return (
    <>

      <section className="kundli_reports">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="details-container">
                <div className="first_name">
                  <p className="first_name_paragraph">Matching Report</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 d-flex text-end align-items-center">
              <div className="present_bar">
                <h5>
                  <p>
                    Matching Points <span className="dayspercent1"></span>
                  </p>
                  <div className="progress-wrapper" style={{ display: "none" }}>
                    <input type="range" value="5" min="0" max="100" step="1" />
                  </div>
                  <div className="progress_brr tops_r">
                    <div
                      className="pie"
                      data-pie={JSON.stringify({
                        speed: 30,
                        percent: 70,
                        stroke: 6,
                        strokeBottom: 6,
                        colorSlice: "#FFAC75",
                        colorCircle: "#C8C8C8",
                        round: true,
                      })}
                      data-pie-index="1"
                      style={{ width: "200px", height: "200px" }}
                    >
                      <svg
                        role="progressbar"
                        width="200"
                        height="200"
                        viewBox="0 0 100 100"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        aria-valuenow="70"
                      >
                        <circle
                          cx="50%"
                          cy="50%"
                          r="42"
                          fill="none"
                          stroke="#C8C8C8"
                          strokeWidth="6"
                        ></circle>
                        <circle
                          cx="50%"
                          cy="50%"
                          r="42"
                          className="pie-circle-1"
                          fill="none"
                          strokeWidth="6"
                          strokeDashoffset="79.2"
                          strokeDasharray="264"
                          strokeLinecap="round"
                          style={{ transform: "rotate(-90deg)", transformOrigin: "50% 50%" }}
                          stroke="#FFAC75"
                          data-angel="70"
                        ></circle>
                        <text
                          className="pie-text-1"
                          x="50%"
                          y="50%"
                          fill="#000"
                          textAnchor="middle"
                          dy="0.35em"
                          fontSize="1.6rem"
                          fontWeight="400"
                        >
                          <tspan className="pie-percent-1">30</tspan>
                          <tspan className="pie-unit-1">%</tspan>
                        </text>
                      </svg>
                    </div>
                  </div>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="basic-table">
        <div className="container-fluid">
          <div className="row">
            <table>
              <thead>
                <tr className="basic-detial">
                  <th>Basic Detail</th>
                  <th>
                    <span className="girl_icon">
                      <img src="./assets/images/girl_ex.svg" alt="Girl Icon" />
                    </span>
                    Girl
                  </th>
                  <th>
                    <span className="girl_icon">
                      <img src="./assets/images/boy_ex.svg" alt="Boy Icon" />
                    </span>
                    Boy
                  </th>
                </tr>
              </thead>
              <tbody className="name-table">
                <tr>
                  <td>Name</td>
                  <td>{girl_name}</td>
                  <td>{boy_name}</td>
                </tr>
                <tr>
                  <td>Day Of Birth</td>
                  <td> {girl_dob}</td>
                  <td> {boy_dob}</td>
                </tr>
                <tr>
                  <td>Time</td>
                  <td>{girl_tob}</td>
                  <td>{boy_tob}</td>
                </tr>
                <tr>
                  <td>Place</td>
                  <td>{girl_birthplace}</td>
                  <td>{boy_birthplace}</td>
                </tr>
                <tr>
                <td>Rashi</td>
                <td>{kundliMatchDetails.bhakoot?.girl_rasi_name || "N/A"}</td>
                <td>{kundliMatchDetails.bhakoot?.boy_rasi_name || "N/A"}</td>
              </tr>
              {/* <tr>
                <td>Nakshatra</td>
                <td>{kundliMatchDetails.nakshatra?.girl_nakshatra || "N/A"}</td>
                <td>{kundliMatchDetails.nakshatra?.boy_nakshatra || "N/A"}</td>
              </tr> */}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="basic-table2">
        <div className="container-fluid">
          <div className="row">
            <table>
              <thead>
                <tr className="basic-detial2">
                  <th>Attribute</th>
                  <th>Girl</th>
                  <th>Boy</th>
                  <th>Points</th>
                  <th>Out Of</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody className="name-table2">
                 {matchAttributes.map((key) => {
              const item = kundliMatchDetails[key];
              return (
                <tr>
                  <td><strong>{item.name}</strong></td>
                  <td>{item[`boy_${key}`] || item.boy_lord || item.boy_rasi_name || item.boy_varna}</td>
                  <td>{item[`girl_${key}`] || item.girl_lord || item.girl_rasi_name || item.girl_varna}</td>
                  <td>{item[key]}</td>
                  <td>{item.full_score}</td>
                  <td>{item.description}</td>
                </tr>
                    );
                })}
              </tbody>
          
              <thead>
                <tr className="basic-detial2">
                  <th>Total Points</th>
                  <th></th>
                  <th></th>
                  <th>{kundliMatchDetails.score}</th>
                  <th>36</th>
                  <th></th>
                </tr>
              </thead>
            </table>
          </div>

          <div className="row pt-5">
            <div className="lorem-text_kundali-report col-12">
              <p><strong>Remarks:</strong> {kundliMatchDetails.bot_response} </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MatchingReport;
